import { render, staticRenderFns } from "./TextBox.vue?vue&type=template&id=6e0248fa&scoped=true&"
import script from "./TextBox.vue?vue&type=script&lang=js&"
export * from "./TextBox.vue?vue&type=script&lang=js&"
import style0 from "./TextBox.vue?vue&type=style&index=0&id=6e0248fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0248fa",
  null
  
)

export default component.exports